import { Box } from '@mui/material';
import { IRequestType } from '../../../constants/interfaces';
import { AccountInfo } from '@azure/msal-browser';
import DashboardHeader from './DashboardHeader';
import RequestTypesPanel from './RequestTypesPanel';
import RequestHistoryPanel from './RequestHistoryPanel';
import { requestFormPageShellSx } from '../../../styles/requestFormShell';

interface StyleClasses {
  button: string;
  content: string;
  error: string;
  errorCenter: string;
  header: string;
  headerControls: string;
  homeMenu: string;
  input: string;
  menuButtonContainer: string;
  sectionTitle: string;
  toggleMargin: string;
}

interface DashboardViewProps {
  classes: StyleClasses;
  sortedRequestTypes: IRequestType[];
  onMenuItemClick: (type: IRequestType) => void;
  activeAccount: AccountInfo | null | undefined;
}

const DashboardView = ({
  classes,
  sortedRequestTypes,
  onMenuItemClick,
  activeAccount,
}: DashboardViewProps) => {
  return (
    <Box
      sx={{
        ...requestFormPageShellSx,
        display: 'flex',
        flexDirection: 'column',
        // Gives the row below a definite height to divide up; without it the
        // panels size to their content and the table has nothing to fill.
        minHeight: { md: 'calc(100vh - 140px)', xs: 'auto' },
      }}
    >
      <DashboardHeader activeAccount={activeAccount} />

      <Box
        sx={{
          alignItems: 'stretch',
          display: 'flex',
          flex: 1,
          flexDirection: { md: 'row', xs: 'column' },
          gap: 3,
          minHeight: 0,
        }}
      >
        <RequestTypesPanel
          classes={classes}
          sortedRequestTypes={sortedRequestTypes}
          onMenuItemClick={onMenuItemClick}
        />

        <RequestHistoryPanel />
      </Box>
    </Box>
  );
};

export default DashboardView;
